import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_algae_cooking_club_gochugaru_chili_oil: FaireProductEntity =
  {
    token: "p_live_algae_cooking_club_gochugaru_chili_oil",
    type: "product",
    name: "Gochugaru Chili Oil",
    brandToken: "b_live_algae_cooking_club",
    brandName: "Algae Cooking Club",
    imageUrl:
      "https://cdn.faire.com/fastly/98587b46d360eae74c8c6a0a3fa5943537aafee05c8c196921e4a8ae85bc86ec.jpeg?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
    priceDollars: 8.5,
    msrpDollars: 17,
    description:
      "Algae Cooking Club gochugaru chili oil used in Live Shopping mocks.",
    categoryTokens: ["cat_food-drink"],
    tags: ["live-shopping", "bestseller", "oils"],
    isBestseller: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T00:00:00.000Z",
      importedBy: "live-shopping-migration",
    },
  };
